import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'jv',
    fullName: 'Javanese',
    nativeName: 'Jawa',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Something Amazing is Coming",
    landing_subtitle: "ArgVoid minangka studio pangembangan aplikasi lan game. Tetep dirungokake, sing anyar bakal teka!",
    select_language: "Pilih Basa",
    search_placeholder: "Telusuri basa...",
    terms_title: "Katentuan Pangginaan supados langkung Service",
    policy_title: "Kebijakan Privasi",
    cookies_title: "Kebijakan cookie",
    terms_content: `
        <strong>1. Ditampa Ketentuan</strong><br>
        Kanthi ngakses ArgVoid, Katentuan Layanan iki ditampa. Yen syarat kasebut ora disepakati, layanan kasebut ora bisa digunakake.<br><br>

        <strong>2. Panggunaan Platform</strong><br>
        ArgVoid lan aplikasi diwenehake "kaya" kanggo tujuan informasi lan kreatif. Layanan kasebut kudu digunakake mung kanggo tujuan sing sah.<br><br>

        <strong>3. Tumindak sing dilarang</strong><br>
        Eksploitasi kerentanan situs, spamming, utawa nyoba akses ora sah menyang infrastruktur dilarang banget.<br><br>

        <strong>4. Penafian</strong><br>
        Platform lan layanan bisa diowahi sawayah-wayah tanpa kabar. Ora ana garansi sing diwenehake babagan wektu aktif utawa kasedhiyan layanan kasebut.
    `,
    policy_content: `
        <strong>1. Koleksi Informasi</strong><br>
        Platform kasebut ora mbutuhake otentikasi pangguna utawa nggawe akun ing wektu iki. Ora ana informasi identifikasi pribadhi (kayata jeneng utawa alamat email) sing aktif diklumpukake saka pengunjung.<br><br>

        <strong>2. Panggunaan Data</strong><br>
        Analitik dhasar lan anonim bisa diklumpukake kanggo mangerteni lalu lintas situs lan nambah aplikasi. Data iki ora disambung karo identitas pangguna individu.<br><br>

        <strong>3. Layanan Pihak Katelu</strong><br>
        Panyedhiya pihak katelu bisa digunakake kanggo layanan hosting lan analytics. Praktek privasi panyedhiya kasebut ngatur data anonim sing diproses ing infrastruktur kasebut.<br><br>

        <strong>4. Keamanan Data</strong><br>
        Langkah-langkah keamanan sing cukup ditindakake kanggo nglindhungi platform kasebut. Nanging, ora ana cara transmisi liwat Internet sing aman.<br><br>
    `,
    cookies_content: `
        <strong>1. Apa Cookie lan Panyimpenan Lokal?</strong><br>
        Cookie lan panyimpenan lokal browser minangka file data cilik sing disimpen ing piranti kanggo ngelingi preferensi konfigurasi sajrone kunjungan.<br><br>

        <strong>2. Dianggo Tujuan</strong><br>
        Browser LocalStorage digunakake kanggo nyimpen setelan konfigurasi, kayata:<br>
        - Preferensi basa<br>
        - Konfigurasi antarmuka pangguna (contone, tata letak utawa setelan tema)<br>
        - Cache aplikasi sauntara<br><br>

        <strong>3. Ora Nglacak</strong><br>
        Cookie lan panyimpenan lokal ora digunakake kanggo iklan utawa tujuan nelusuri pihak katelu. Kabeh data sing disimpen mung kanggo fungsi inti saka platform.<br><br>

        <strong>4. Kontrol</strong><br>
        Data browser bisa dibusak sawayah-wayah liwat setelan browser, sing bakal ngreset konfigurasi lokal.
    `,
    cookie_consent_text: "Kita nggunakake cookie dhasar kanggo mesthekake fungsi situs web kanthi bener, kayata tetep sesi aktif, nyimpen preferensi basa, lan konfigurasi khusus liyane.",
    read_policy: "Waca Kebijakan Cookie",
    support_title: "Kontak Dhukungan",
    support_subject_label: "Subyek",
    support_message_label: "Pesen",
    support_submit_button: "Kirimi Pesen",
    support_hint: "Cathetan: Iki bakal mbukak aplikasi email standar kanggo ngirim pesen.",
    support_success_msg: "Mbukak aplikasi email sampeyan...",
    support_error_msg: "Gagal ngirim pesen. Mangga coba maneh mengko.",
    explorer_title: "panjelajah",
    history_title: "Sajarah",
    animation_title: "Animasi",
    config_title: "Konfigurasi",
    tool_mouse: "Pilih (Ctrl+M)",
    tool_brush: "Sikat (Ctrl+B)",
    tool_brush_mode: "Mode Ngalih (Padhet/Bening)",
    tool_eraser: "Penghapus (Ctrl+E)",
    tool_brush_size: "Nyetel Ukuran Brush",
    tool_bucket: "Isi (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Puter (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Jembar",
    label_height: "dhuwur",
    label_frames: "Jumlah Frames",
    label_animation: "Gaya Animasi",
    label_background_color: "Werna latar mburi",
    label_interval: "Interval",
    tool_anim_config: "Konfigurasi Animasi",
    label_new_width: "Jembar Anyar",
    label_new_height: "Dhuwur Anyar",
    label_apply: "nglamar",
    label_colors: "werna-werna",
    label_size: "Ukuran",
    label_tolerance: "Toleransi",
    val_horizontal: "Horisontal",
    val_vertical: "Vertikal",
    val_sequence: "urut-urutan",
    val_bounce: "mumbul",
    val_random: "Acak",
    val_solid: "Padat",
    val_clear: "Cetha",
    action_add_sheet: "Lembaran Anyar",
    action_import: "Ngimpor",
    action_export: "Ekspor",
    action_sort_projects: "Urut",
    sort_date_old: "Paling tuwa pisanan",
    sort_date_new: "Newest First",
    sort_name_az: "Jeneng (A-Z)",
    sort_name_za: "Jeneng (Z-A)",
    action_new_sprite: "Sprite anyar",
    action_new_project: "Proyek Anyar",
    modal_save_all_title: "Simpen Kabeh Owah-owahan",
    modal_save_all_desc: "Pilih aset kanggo disimpen:",
    modal_save_selected: "Simpen Dipilih",
    action_saved: "Disimpen",
    modal_create_sprite_title: "Nggawe Sprite Anyar",
    modal_create_project_title: "Nggawe Proyek Anyar",
    modal_add_sheet_title: "Tambah Lembar Anyar",
    modal_rename_sheet_title: "Ganti jeneng Sheet",
    modal_rename_sprite_title: "Ganti jeneng Sprite",
    modal_delete_sprite_title: "Mbusak Sprite",
    modal_delete_project_title: "Mbusak Project",
    modal_delete_sheet_title: "Mbusak Lembar",
    placeholder_sprite_name: "jeneng",
    placeholder_project_name: "jeneng",
    placeholder_sheet_name: "jeneng",
    placeholder_new_name: "Jeneng Anyar",
    action_create: "Nggawe",
    action_add: "Tambah",
    action_rename: "Ganti jeneng",
    action_duplicate: "Duplikat",
    action_delete: "Mbusak",
    action_cancel: "Batal",
    confirm_delete_sprite: "Apa sampeyan yakin pengin mbusak sprite iki?",
    confirm_delete_project: "Apa sampeyan yakin pengin mbusak proyek iki? Kabeh sprites bakal dibusak.",
    confirm_delete_sheet: "Apa sampeyan yakin arep mbusak sheet iki?",
    err_select_sprite: "Mangga pilih sprite pisanan.",
    err_select_project: "Mangga pilih proyek dhisik.",
    err_name_empty: "Jeneng ora bisa kosong.",
    err_sprite_exists: "A sprite karo jeneng sing wis ana.",
    err_project_exists: "Proyek kanthi jeneng kasebut wis ana.",
    err_no_content: "Ora ana isi kanggo nyimpen.",
    err_no_changes: "Ora ana owah-owahan kanggo nyimpen.",
    err_delete_last_sheet: "Ora bisa mbusak lembar pungkasan.",
    err_extract_frames: "Ora bisa ngekstrak pigura apa wae.",
    err_indexeddb: "Gagal nyimpen sacara lokal. Browser sampeyan bisa uga ora ndhukung IndexedDB.",
    msg_upload_success: "Unggahan Kasil: {0}",
    msg_upload_failed: "Unggahan Gagal: {0}",
    msg_save_success: "Simpen sukses.",
    msg_saving: "Ngirit...",
    msg_multi_save_result: "Aset {0} disimpen. {1} gagal.",
    menu_title: "Menu",
    menu_save: "Simpen",
    menu_save_all: "Simpen Kabeh",
    menu_support: "Kontak Dhukungan",
    label_local_storage: "Panyimpenan Lokal",
    label_sign_in: "Mlebu",
    modal_export_title: "Ekspor Sprite",
    label_filename: "Jeneng berkas",
    label_format: "Format",
    action_export_confirm: "Ekspor",
};

export default translations;
